import { baseApi, REMOTE_PAYMENT_METHODS_TAG } from '@/shared';

import { remotePaymentMethodsAdapter } from '../utils/helpers/adapter';

import type {
  TGetRemoteMethodsByPaymentSystemParams,
  TGetRemoteMethodsByCurrnecyParams,
  TRemotePaymentMethod,
  TRemotePaymentMethodCreateParams,
  TRemotePaymentMethodUpdateParams,
  TRemotePaymentMethodDeleteParams,
} from './types';

export const remotePaymentMethodsApi = baseApi.injectEndpoints({
  endpoints: build => ({
    getRemotePaymentMethodsByPaymentSystem: build.query<TRemotePaymentMethod[], TGetRemoteMethodsByPaymentSystemParams>({
      query: (params: TGetRemoteMethodsByPaymentSystemParams) => ({
        url: `/admin/remote_methods/list/${params.paymentSystemId}`,
      }),
      transformResponse: remotePaymentMethodsAdapter,
      providesTags: [REMOTE_PAYMENT_METHODS_TAG],
    }),

    getRemotePaymentMethodsByCurrency: build.query<TRemotePaymentMethod[], TGetRemoteMethodsByCurrnecyParams>({
      query: (params: TGetRemoteMethodsByCurrnecyParams) => ({
        url: `/admin/remote_methods/list/currency/${params.currency}`,
      }),
      transformResponse: remotePaymentMethodsAdapter,
      providesTags: [REMOTE_PAYMENT_METHODS_TAG],
    }),

    createRemotePaymentMethod: build.mutation<void, TRemotePaymentMethodCreateParams>({
      query: (params: TRemotePaymentMethodCreateParams) => ({
        url: '/admin/remote_methods/create',
        method: 'POST',
        body: {
          payment_system_id: params.paymentSystemId,
          currency: params.currency,
          name: params.name,
          data: params.data,
          min_refill: params.minRefill,
          max_refill: params.maxRefill,
        },
      }),
      invalidatesTags: [REMOTE_PAYMENT_METHODS_TAG],
    }),

    updateRemotePaymentMethod: build.mutation<void, TRemotePaymentMethodUpdateParams>({
      query: ({ methodId, ...params }: TRemotePaymentMethodUpdateParams) => ({
        url: `/admin/remote_methods/update/${methodId}`,
        method: 'PUT',
        body: {
          currency: params.currency,
          name: params.name,
          data: params.data,
          min_refill: params.minRefill,
          max_refill: params.maxRefill,
        },
      }),
      invalidatesTags: [REMOTE_PAYMENT_METHODS_TAG],
    }),

    deleteRemotePaymentMethod: build.mutation<void, TRemotePaymentMethodDeleteParams>({
      query: (params: TRemotePaymentMethodDeleteParams) => ({
        url: `/admin/remote_methods/delete/${params.methodId}`,
        method: 'DELETE',
      }),
      invalidatesTags: [REMOTE_PAYMENT_METHODS_TAG],
    }),

  }),
});

export const {
  useGetRemotePaymentMethodsByPaymentSystemQuery,
  useGetRemotePaymentMethodsByCurrencyQuery,
  useCreateRemotePaymentMethodMutation,
  useUpdateRemotePaymentMethodMutation,
  useDeleteRemotePaymentMethodMutation,
} = remotePaymentMethodsApi;
